import request from '@/utils/request'

// 获取开发者基本信息
export function getDeveloperBaseInfo (params) {
  const req = request({
    method: 'get',
    url: '/developer/baseinfo',
    params: params
  })

  return req
}

// 获取经办人列表
export function getSignerList (params) {
  const req = request({
    method: 'get',
    url: '/user/signer/userlist',
    params: params
  })

  return req
}

// 创建经办人
export function createSigner (data) {
  const req = request({
    method: 'post',
    url: '/user/signer/createsigner',
    data: data
  })

  return req
}

// 更新经办人信息
export function updateSigner (data) {
  const req = request({
    method: 'post',
    url: '/user/signer/updatesigner',
    data: data
  })

  return req
}

// 删除经办人
export function deleteSigner (data) {
  const req = request({
    method: 'post',
    url: '/user/signer/deletesigner',
    data: data
  })

  return req
}

// 获取银行信息
export function getBankAccountInfo (params) {
  const req = request({
    method: 'get',
    url: '/bank/accounts/developer/' + params.devId
  })

  return req
}

// 获取默认银行列表
export function getDefaultBankList () {
  const req = request({
    method: 'get',
    url: '/bank/defaultbanklist'
  })

  return req
}

// 更新银行账户信息
export function updateBankAccount (params) {
  const req = request({
    method: 'put',
    url: '/bank/accounts/' + params.bank_account_id,
    data: params
  })

  return req
}

export function createBankAccount (params) {
  const req = request({
    method: 'post',
    url: '/bank/accounts',
    data: params
  })

  return req
}

// 获取商务联系人
export function getBusinessContacts (params) {
  const req = request({
    method: 'get',
    url: '/contacts/business/developer/' + params.developer_id
  })

  return req
}

// 更新商务联系人
export function updateBusinessContacts (params) {
  const req = request({
    method: 'put',
    url: '/contacts/business/update/' + params.contacts_id,
    data: params
  })

  return req
}

// 创建商务联系人
export function createBusinessContacts (params) {
  const req = request({
    method: 'post',
    url: '/contacts/business/create',
    data: params
  })

  return req
}

// 获取财务联系人
export function getFinanceContacts (params) {
  const req = request({
    method: 'get',
    url: '/contacts/finance/developer/' + params.developer_id
  })

  return req
}

// 更新财务联系人
export function updateFinanceContacts (params) {
  const req = request({
    method: 'put',
    url: '/contacts/finance/update/' + params.contacts_id,
    data: params
  })

  return req
}

// 创建财务联系人
export function createFinanceContacts (params) {
  const req = request({
    method: 'post',
    url: '/contacts/finance/create',
    data: params
  })

  return req
}

// 获取更名涵
export function getRenameLetterList (params) {
  const req = request({
    method: 'get',
    url: '/renameletter/findrenamelist',
    params: params
  })

  return req
}

// 新增更名信息
export function createRenameLetter (params) {
  const req = request({
    method: 'post',
    url: '/renameletter/createrenameletter',
    data: params
  })

  return req
}

// 删除更名信息
export function delRenameLetter (params) {
  const req = request({
    method: 'post',
    url: '/renameletter/delrenameinfo',
    data: params
  })

  return req
}

// 获取签署过程中cp需要确认的信息
export function getCpConfirmInfo (params) {
  const req = request({
    method: 'get',
    url: '/contracts/signprocess/getcpconfirminfo',
    params: params
  })

  return req
}
